import { render, staticRenderFns } from "./FormAlignmentMGHRWC.vue?vue&type=template&id=8c0e6aa8&scoped=true&"
import script from "./FormAlignmentMGHRWC.vue?vue&type=script&lang=ts&"
export * from "./FormAlignmentMGHRWC.vue?vue&type=script&lang=ts&"
import style0 from "./FormAlignmentMGHRWC.vue?vue&type=style&index=0&id=8c0e6aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0e6aa8",
  null
  
)

export default component.exports